import { Box, Typography } from "@mui/material";

export const Profile = () => {
  return (
    <Box
      height="50vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="h5">Profile Goes Here</Typography>
    </Box>
  );
};
